// extracted by mini-css-extract-plugin
export default {"date":"_384w"};